import React from 'react';
import { useLanguage } from './LanguageContext';

// Импортируем ваши три иконки
import deliveryIcon from './assets/delivery-icon.png';
import comfortIcon from './assets/feature-icon-4.svg';
import qualityIcon from './assets/quality-icon.png';

const Features = () => {
  const { t } = useLanguage();

  return (
    <section className="features-section">
      <div className="features-container">
        <div className="feature-item">
          <img src={deliveryIcon} alt={t('freeDelivery')} />
          <h3>{t('freeDelivery')}</h3>
          <p>{t('freeDeliveryDesc')}</p>
        </div>
        <div className="feature-item">
          <img src={comfortIcon} alt={t('individualComfort')} />
          <h3>{t('individualComfort')}</h3>
          <p>{t('individualComfortDesc')}</p>
        </div>
        <div className="feature-item">
          <img src={qualityIcon} alt={t('qualityGuarantee')} />
          <h3>{t('qualityGuarantee')}</h3>
          <p>{t('qualityGuaranteeDesc')}</p>
        </div>
      </div>
    </section>
  );
};

export default Features;